export default "<p>bank-card works!</p>\n"